export default __webpack_public_path__ + "static/PES5-bf3b57bcf179be1b6f8863b5f29ec775.jpg";